import { render, staticRenderFns } from "./04_Dienstleistungen.vue?vue&type=template&id=168d31ad&"
import script from "./04_Dienstleistungen.vue?vue&type=script&lang=js&"
export * from "./04_Dienstleistungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports